import Lottie from "react-lottie";
import { NavLink } from "react-router-dom";
import aboutAnimation from "assets/lottie/general/anim_09.json"; // Correct Lottie animation path
import animationData from "assets/lottie/cool/cool_05.json";

const Logo = () => (
  <span className="font-title font-extrabold leading-tight">
    <span
      style={{ fontFamily: "Barriecito, sans-serif" }}
      className="text-yellow-400"
    >
      BitBit
    </span>{" "}
    Studio
  </span>
);

const About = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: aboutAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };
  const defaultOptionsB = {
          loop: true,
          autoplay: true,
          animationData: animationData
    };

  return (
    <> 
        {/* main section */}
        <div className="w-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white py-16 px-4 flex flex-col items-center justify-center">
        <h1 className="text-4xl md:text-5xl font-title font-extrabold text-center">
            About Us
        </h1>

        <div className="flex flex-col lg:flex-row items-center justify-center w-full lg:w-[90%]">
            {/* Lottie Animation */}
            <div className="w-full lg:w-[40%]">
                <Lottie options={defaultOptions} />
            </div>

            {/* About Text Content */}
            <div className="w-full lg:w-1/2 text-center lg:text-left">
            <p className="text-lg md:text-xl font-body leading-relaxed mb-8">
                At <Logo />, we are passionate about creating unique, high-quality
                animations that bring stories to life. Our boutique approach ensures
                a personal connection with every client, allowing us to craft custom
                solutions tailored to their vision.
            </p>
            <p className="text-lg md:text-xl font-body leading-relaxed">
                With a team of talented animators, designers, and creative minds, we
                specialize in everything from corporate explainers and music videos
                to festival visuals and artistic projects. Let’s make something
                amazing together!
            </p>
            </div>
        </div>
        </div>

        {/* Call to Action Section */}
        <div className="text-white w-full my-16 text-center bg-contain bg-no-repeat bg-center" style={{
            // backgroundImage: `url(${bgDesktop})`,
        }}>
            <Lottie width="200px" options={defaultOptionsB} isClickToPauseDisabled={true} style={{cursor:"default"}}/>
            <h2 className="text-3xl md:text-4xl font-title font-extrabold mb-6">
            Ready to Bring Your Vision to Life?
            </h2>
            <p className="text-lg md:text-xl font-body mb-8">
            Let’s collaborate and create something extraordinary.
            </p>
            <NavLink to="/contact">
                <button className="hover:scale-110 text-xl px-8 py-4 bg-yellow-400 text-indigo-900 font-title font-semibold rounded-full shadow hover:tracking-widest transition-all duration-300">
                    Let's Chat!
                </button>
            </NavLink>
        </div>
  </>
  );
};

export default About;
